import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';

const ProfileOrders_1 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const products = useSelector(state => state.themeSlice.products);
  const firstProduct = products && Object.values(products)?.[0];

  return (
    <div className="w-full h-full relative">
      <div
        style={{
          display: 'flex',
          padding: staticValues[15],
          gap: 15,

          margin: 10,
          borderRadius: 10,
          borderWidth: 0.5,
          borderStyle: 'solid',
          borderColor: 'var(--secondaryThemeColor)',
        }}
      >
        <div style={{ display: 'flex' }}>
          <div>
            <img
              style={{
                width: 100,
                height: '100%',
                borderRadius: 10,
                objectFit: customization?.backgroundSize,
              }}
              src={firstProduct?.image}
            />
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1, color: 'var(--secondaryThemeColor)' }}>
          <div style={{ textAlign: 'start', display: 'flex', flexDirection: 'column', flex: 1 }}>
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>Order Number:</div>
            <div style={{ fontSize: 16, fontWeight: 'bold' }}>APP26887QAR</div>

            <div style={{ fontSize: staticValues[10], fontWeight: 600 }}>Quantity: 2</div>
            <div style={{ fontSize: staticValues[10], fontWeight: 600 }}>Order status: Created</div>
            <div style={{ fontSize: staticValues[10] }}>Payment Type: Card</div>
            <div style={{ fontSize: staticValues[10] }}>Package Status: Fulfilled</div>
            <div style={{ fontSize: staticValues[10] }}>Payment Status: Paid</div>

            {/* {firstProduct?.data?.productVariantTypes?.map((variantType, index) => (
              <div key={index} style={{ color: 'var(--secondaryThemeColor)', fontSize: staticValues[10] }}>
                {variantType?.variantType?.name}: {variantType?.variantType?.values?.[0]?.name}
              </div>
            ))} */}
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
              <div style={{ fontSize: staticValues[14], fontWeight: 'bold' }}>
                ₺{firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 0.9}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileOrders_1;
